module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.b84319e9.mp3";